// extracted by mini-css-extract-plugin
export var addButton = "_p0-0";
export var border = "_p0-8";
export var check = "_p0-h";
export var danger = "_p0-6";
export var dropdownContainer = "_p0-1";
export var editModalBody = "_p0-j";
export var footerContainer = "_p0-i";
export var fullWidth = "_p0-a";
export var hide = "_p0-9";
export var icon = "_p0-3";
export var input = "_p0-7";
export var inputFlex = "_p0-b";
export var inputWrapper = "_p0-c";
export var manualFocus = "_p0-5";
export var optionButton = "_p0-4";
export var pillWrapper = "_p0-e";
export var pointer = "_p0-2";
export var showOverflow = "_p0-f";
export var tagsFlex = "_p0-d";
export var xButton = "_p0-g";